export default [
  {
    id: 1,
    phrase: '"A photograph is a fragment of time that will not return"',
    author: "Martine Franck",
  },
  {
    id: 2,
    phrase: '"Photography is a brief complicity between foresight and luck"',
    author: "John Stuart Mill",
  },
  {
    id: 3,
    phrase: '"Photography is a brief complicity between foresight and luck"',
    author: "John Stuart Mill",
  },
  {
    id: 4,
    phrase: '"Photography is a brief complicity between foresight and luck"',
    author: "John Stuart Mill",
  },
  {
    id: 5,
    phrase: '"Photography is a brief complicity between foresight and luck"',
    author: "John Stuart Mill",
  }
];
